"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatDashboard = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var chatBase_1 = require("../chatBase");
var ChatDashboard = /** @class */ (function (_super) {
    __extends(ChatDashboard, _super);
    function ChatDashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollToTopRef = (0, react_1.createRef)();
        _this.componentDidUpdate = function (prevProps) {
            if (JSON.stringify(_this.props.conversationList) !==
                JSON.stringify(prevProps.conversationList))
                _this.handleScrollToLatestMessage();
        };
        _this.handleScrollToLatestMessage = function () {
            var _a;
            (_a = _this.scrollToTopRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        };
        _this.handleSelectedConversation = function (id) {
            var _a, _b;
            (_b = (_a = _this.props).handleSelectedConversation) === null || _b === void 0 ? void 0 : _b.call(_a, id);
        };
        _this.renderUserList = function () {
            var userChatList = [];
            var conversationCount = _this.props.conversationList.length;
            if (conversationCount > 0) {
                _this.props.conversationList.map(function (eachConversation, index) {
                    var otherUser = eachConversation.members.find(function (eachMember) {
                        return eachMember.id !== _this.props.currentUser.id;
                    });
                    if (otherUser) {
                        userChatList.push(react_1.default.createElement("div", { onClick: function () {
                                return _this.handleSelectedConversation(eachConversation.id);
                            }, className: "p-4 flex items-center ".concat(index === conversationCount - 1 ? "" : "border-b", " border-gray-300 hover:bg-gray-300 hover:cursor-pointer") },
                            react_1.default.createElement("img", { src: otherUser.imageUrl, alt: "", className: "w-8 h-8 rounded-full" }),
                            react_1.default.createElement("div", { className: "flex flex-col ml-5" },
                                react_1.default.createElement("div", { className: "font-bold text-indigo-600" }, otherUser.name),
                                react_1.default.createElement("div", { className: "text-xs" }, eachConversation.messageList[eachConversation.messageList.length - 1].messageBody))));
                    }
                    return null;
                });
                return userChatList;
            }
        };
        return _this;
    }
    ChatDashboard.prototype.render = function () {
        var _a, _b;
        return (react_1.default.createElement("div", { className: "w-full flex border-2 rounded-md b-black" },
            react_1.default.createElement("div", { className: "chat-scrollbar ".concat((_a = this.props.sizeClassName) !== null && _a !== void 0 ? _a : "h-[75vh]", " ").concat((_b = this.props.className) !== null && _b !== void 0 ? _b : "bg-white border-rounded-md border-gray-300 border-r-2", " ").concat(this.props.mobileSelectedChat ? "hidden" : "flex", " sm:flex overflow-y-auto") },
                react_1.default.createElement("div", { className: "w-full h-fit flex flex-col" },
                    react_1.default.createElement("div", { ref: this.scrollToTopRef }),
                    this.renderUserList())),
            react_1.default.createElement(chatBase_1.ChatBase, { value: this.props.value, searchMessage: this.props.searchMessage, currentUser: this.props.currentUser, conversation: this.props.selectedConversation, bodyElement: this.props.bodyElement, headerElement: this.props.headerElement, className: " ".concat(this.props.chatBaseClassName, " ").concat(!this.props.mobileSelectedChat ? "hidden" : "", " sm:flex overflow-y-auto"), sizeClassName: this.props.chatBaseSizeClassName, onSendMessage: this.props.onSendMessage, onChangeMessage: this.props.onChangeMessage, onChangeSearch: this.props.onChangeSearch, onSearch: this.props.onSearch })));
    };
    return ChatDashboard;
}(react_1.Component));
exports.ChatDashboard = ChatDashboard;
//# sourceMappingURL=index.js.map